<template>
  <el-card>
    <el-row class="search">
      <span>功能:</span>
      <el-select v-model="search.type" style="width:160px" filterable class="ma">
        <el-option label='推荐视频' :value="0"></el-option>
        <el-option label='话术资源' :value="1"></el-option>
      </el-select>
      <span>类型:</span>
      <el-select v-model="search.resourceScale" style="width:160px" filterable class="ma">
        <el-option label='全部' :value="-1"></el-option>
        <el-option label='常规' :value="0"></el-option>
        <el-option label='Hot' :value="1"></el-option>
      </el-select>
      <span>主播rid:</span>
      <el-input v-model="search.hostRid" placeholder="主播rid" clearable></el-input>
      <span>国家:</span>
      <el-select v-model="search.countryCode" style="width:160px" filterable class="ma" clearable placeholder="国家">
        <el-option v-for="(item, i) in countryList" :key="i" :label="item == '' ? '全部' : item" :value="item">
        </el-option>
      </el-select>
      <span>状态:</span>
      <el-select v-model="search.valid" style="width:160px" filterable clearable class="ma" placeholder="状态">
        <el-option label="全部" value=""> </el-option>
        <el-option label="上架" value="1"> </el-option>
        <el-option label="下架" value="0"> </el-option>
      </el-select>
      <el-button type="primary" @click="query(0)">查询</el-button>
      <el-button type="danger" @click="operate(1)">新增</el-button>
    </el-row>
    <el-row>
      <el-table :data="list" style="width: 100%" height="600" stripe border v-loading="loading">
        <el-table-column prop="hostRid" label="主播rid" width="180">
        </el-table-column>
        <el-table-column prop="hostUid" label="主播uid"> </el-table-column>

        <el-table-column prop="hostCountry" label="主播国家代码">
        </el-table-column>
        <el-table-column prop="duration" label="视频时长"> </el-table-column>
        <el-table-column prop="type" label="功能"><template slot-scope="scope">
            {{ scope.row.type == 0 ? '推荐视频' : '话术资源' }}
          </template>
        </el-table-column>
        <el-table-column prop="resourceType" label="资源类型">
          <template slot-scope="scope">
            {{ scope.row.resourceType == 0 ? '视频资源' : '图片资源' }}
          </template>
        </el-table-column>
        <el-table-column prop="resourceScale" label="类型">
          <template slot-scope="scope">
            {{ scope.row.resourceScale == 0 ? '常规' : 'Hot' }}</template>
        </el-table-column>
        <el-table-column prop="valid" label="是否上架">
          <template slot-scope="scope">
            {{ scope.row.valid == 1 ? '上架' : '下架' }}</template>
        </el-table-column>
        <el-table-column prop="mtime" label="修改时间">
          <template slot-scope="scope">
            {{ format_(scope.row.mtime) }}
          </template>
        </el-table-column>

        <el-table-column prop="resourceType" label="资源" align="center">
          <template slot-scope="scope">
            <el-image :src="scope.row.url" alt="资源" v-if="scope.row.resourceType === 1">
            </el-image>
            <el-button type="text" @click="look(scope.row.url)" v-else>
              播放
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="operator" label="操作人"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- <el-button type="text" @click="look(scope.row.url)">
              播放
            </el-button> -->
            <el-button type="text" @click="operate(3, scope.row, scope.row.id)">
              编辑
            </el-button>
            <el-button type="text" @click="operate(4, scope.row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-pagination @current-change="query" :current-page.sync="currentPage" :page-size="20"
        layout="total, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-row>

    <!-- 添加视频 -->
    <el-dialog :title="type ? '添加视频' : '编辑视频'" :visible.sync="dialogVisible" width="500px" :before-close="closeBefore"
      :close-on-click-modal="false">
      <el-row>
        <span>主播Rid：</span>
        <el-input placeholder="请输入主播Rid" clearable v-model="video.hostRid"></el-input>
      </el-row>
      <el-row>
        <span>时长：</span>
        <el-input placeholder="请输入时长" clearable v-model="video.duration"></el-input>
      </el-row>
      <el-row>
        <span>是否上架：</span>
        <el-switch v-model="video.valid" active-text="上架" inactive-text="下架" :active-value="1" :inactive-value="0">
        </el-switch>
      </el-row>
      <el-row>
        <span style="width: 120px;display: inline-block;">功能:</span>
        <el-select v-model="video.type" style="width:160px" filterable class="ma">
          <el-option label='推荐视频' :value="0"></el-option>
          <el-option label='话术资源' :value="1"></el-option>
        </el-select>
      </el-row>
      <el-row>
        <span style="width: 120px;display: inline-block;">资源类型:</span>
        <el-select v-model="video.resourceType" style="width:160px" filterable class="ma">
          <el-option label='视频资源' :value="0"></el-option>
          <el-option label='图片资源' :value="1"></el-option>
        </el-select>
      </el-row>

      <el-row v-if="video.type == 0">
        <span style="width: 120px;display: inline-block;">类型:</span>
        <el-select v-model="video.resourceScale" style="width:160px" filterable class="ma">
          <el-option label='常规' :value="0"></el-option>
          <el-option label='Hot' :value="1"></el-option>
        </el-select>
      </el-row>

      <el-row>
        <span>资源上传：</span>
        <el-upload drag action="" ref="upload" :file-list="fileList1" :auto-upload="false" :on-change="changeVideo">
          <div v-if="showProgress">
            <el-progress style="marginTop:15px" type="circle" :percentage="uploadPercent"></el-progress>
            <div class="el-upload__text">请耐心等候上传</div>
          </div>
          <div v-else>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </div>
        </el-upload>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeBefore">取 消</el-button>
        <el-button type="primary" @click="operate(2)" v-if="type">
          确 定
        </el-button>
        <el-button type="primary" @click="operate(5)" v-else>
          编 辑
        </el-button>
      </span>
    </el-dialog>

    <div v-show="videoParams.vid" class="po">
      <i @click="look_()" class="el-icon-circle-close pos" style="z-index: 9999"></i>
      <video id="video" preload="auto" muted size="medium" type="application/x-mpegURL" src=""
        class="video-js vjs-default-skin" style="width: 480px; height: 640px; object-fit: fill"></video>
    </div>
  </el-card>
</template>

<script>
import {
  getRecommendedVideoList,
  getRecommendedCountry,
  uploadRecommendedVideo,
  updateRecommendedVideo,
  delRecommendedVideo
} from '@/api/video.js'
import videojs from 'video.js'
import 'videojs-contrib-hls'
export default {
  data() {
    return {
      list: [],
      countryList: [],
      loading: false,
      currentPage: 0,
      total: 0,
      showProgress: false, //是否展示进度条
      uploadPercent: 0, // 进度条进度
      search: { hostRid: '', countryCode: '', valid: '', type: 0, resourceScale: -1 },
      video: {
        hostRid: '',
        duration: '',
        valid: 0,
        video: '',
        type: 0,
        resourceType: 0,
        resourceScale: 0
      },
      videoParams: {
        index_: '',
        vid: false
      },
      type: true,
      dialogVisible: false,
      fileList1: [],
      myPlayer: {}
    }
  },
  mounted() {
    this.query(0)
    this._countryList()
  },
  methods: {
    async _countryList() {
      const res = await getRecommendedCountry()
      this.countryList = res.data.list
    },
    look_() {
      this.videoParams.vid = false
      this.myPlayer = videojs('video') //获取video的id值
      this.myPlayer.pause()
      this.myPlayer = {}
    },
    look(url) {
      this.videoParams.vid = true
      setTimeout(() => {
        this.myPlayer = videojs('video') //获取video的id值
        this.myPlayer.src(url)
        this.myPlayer.load(url)
        this.myPlayer.play()
      }, 100)
    },
    async query(num) {
      if (num == 0) this.currentPage = 1
      this.loading = true
      try {
        const res = await getRecommendedVideoList(
          {
            page: this.currentPage
          },
          { ...this.search }
        )
        this.loading = false
        this.list = res.data.list
        this.total = res.data.totalCount
      } catch (error) {
        this.loading = false
      }
    },
    format_(data) {
      let date = new Date(data * 1000) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '-'
      let M =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-'
      let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      let h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      let m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
      let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    async operate(type, obj, id) {
      console.log(id);
      if (type == 1) {
        this.type = true
        this.dialogVisible = true
      } else if (type == 2) {
        this.addVideo()
      } else if (type == 3) {
        this.type = false
        this.dialogVisible = true
        this.video = { id, ...obj }
      } else if (type == 4) {
        this.$confirm('确认删除？')
          .then(async () => {
            const res = await delRecommendedVideo({ id: obj })
            if (res.code !== 0) return this.$message.error(res.msg)
            this.$message.success('删除成功')
            this.query()
          })
          .catch(() => { })
      } else if (type == 5) {
        if (this.video.video == undefined) {
          this.updateVideo(this.video.id)
        } else {
          this.addVideo(this.video.id)
        }
      } else if (type == 6) {
      }
    },
    async addVideo(id) {
      this.showProgress = true
      const formData = new FormData()
      formData.append('hostRid', this.video.hostRid)
      formData.append('duration', this.video.duration)
      formData.append('valid', this.video.valid)
      formData.append('video', this.video.video)
      formData.append('type', this.video.type)
      formData.append('resourceType', this.video.resourceType)
      if (this.video.type) {
        this.video.resourceScale = 0
      }
      formData.append('resourceScale', this.video.resourceScale)
      console.log('id', id);
      if (id) {
        formData.append('id', id)
      }

      uploadRecommendedVideo(formData, e => {
        if (this.uploadPercent == 99) return
        this.uploadPercent = parseInt((e.loaded / e.total) * 100)
      }).then(res => {
        if (res.code != 0) {
          this.uploadPercent = 0
          this.showProgress = false
          return this.$message.error(res.msg)
        }
        this.uploadPercent = 100
        this.showProgress = false
        this.closeBefore()
        this.$message.success('上传成功')
        this.query()
      })
    },
    async updateVideo(id) {
      if (this.video.type) {
        this.video.resourceScale = 0
      }
      const res = await updateRecommendedVideo({
        id,
        ...this.video
      })
      if (res.code !== 0) return this.$message.error(res.msg)
      this.$message.success('更新成功')
      this.closeBefore()
      this.query()
    },
    // 改变视频文件
    changeVideo(res, files) {
      this.fileList1 = []
      let file = files[files.length - 1]
      let name = file.name
      this.video.video = file.raw
      this.fileList1.push({ name })
    },
    closeBefore() {
      this.dialogVisible = false
      this.$refs.upload.clearFiles()
      this.video = {
        hostRid: '',
        duration: '',
        valid: 0,
        video: '',
        type: 0,
        resourceType: 0,
        resourceScale: 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search {
  display: flex;
  align-items: center;

  >* {
    margin: 2px;
  }

  .el-input {
    max-width: 250px;
  }
}

.po {
  width: 480px;
  height: 640px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}

.pos {
  position: absolute;
  top: 10px;
  right: -50px;
  transform: scale(2);
}
</style>
